export default __webpack_public_path__ + "ku_dark_fr.672b1ce8.svg";